import { DateTime, Settings } from 'luxon';
import memoize from 'lodash/memoize';

import { DEFAULT_LEAP_YEAR } from './birthdays';

/**
 * Builds a new Intl.DateTimeFormat once per language asked (memoized).
 * Having this memoized is important since building one of these objects is expensive
 */
const getDayMonthIntlFormat = memoize(language => new Intl.DateTimeFormat(language, { month: 'long', day: 'numeric', timeZone: 'utc' }));

// eslint-disable-next-line import/prefer-default-export
export function toLongDateFormat({ day, month, year }) {
  const luxonDate = DateTime.fromObject({
    day,
    month,
    year: year || DEFAULT_LEAP_YEAR,
    zone: 'utc',
  });
  return year
    ? luxonDate.toFormat('DDD')
    : getDayMonthIntlFormat(Settings.defaultLocale).format(luxonDate.toJSDate());
}
